export const data = {
  topic: "PureCSS",
  time: "2hrs",
  desc: ` Height is optional, if no height is specified the image will be a
  square.Example:`,
  text1: "A quick and simple image placeholder service. | PLACEHOLDER.it",
  text2: `How does it work? Just put your image size after our URL and you'll
  get a placeholder.`,
  text3: "placeholder it"
};
